import React from "react";

import useStyles from "./styles";
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const  NoRecord = (view,module='',subpanel_module='') => {
  // console.log("NoRecord view",view);
  const classes = useStyles();
  if(view.view === 'subpanel')
  {
    return (
      <div className={classes.notFoundContainer}>
        <div className={classes.textboxClass}>
          <ErrorOutlineIcon />
          <h2>No Records Found</h2>
          {subpanel_module && ['Activities','History','SecurityGroups'].includes(subpanel_module)?<p>Would you like to create or select record?</p>:null} 
        </div>
      </div>
    );
  }
  else if(view.view === 'dashlet_report')
  {
    return (
      <div className={classes.notFoundContainer}>
        <div className={classes.textboxClass} style={{padding:"0px"}}>
          <h2>Choose Report</h2>
        </div>
      </div>
    );
  }
  else if(view.view === 'dashlet_no_data')
  {
    return (
      <div className={classes.notFoundContainer}>
        <div className={classes.textboxClass} style={{padding:"0px"}}>
          <h2>No data</h2>
        </div>
      </div>
    );
  }
  else
  {
    return (
      <div className={classes.notFoundContainer}>
  
  
  <div className={classes.textboxClass}>
  <ErrorOutlineIcon />
        <h2>No Records found</h2>
        <p>If this module don't have data or Perhaps change your search criteria and try again?</p> 
      </div>
  
      
  </div>



    );
  }
  
}


export default NoRecord;